import { IconName } from '@zenchef/icomoon'
import i18n from 'i18next'

export const calendarActions = (getCalendarLinkHandler): { value: string; label: string; icon: IconName }[] => {
  return [
    {
      value: getCalendarLinkHandler('GOOGLE'),
      label: i18n.t('calendar.google'),
      icon: 'google-google'
    },
    {
      value: getCalendarLinkHandler('OUTLOOK'),
      label: i18n.t('calendar.outlook'),
      icon: 'outlook'
    },
    {
      value: getCalendarLinkHandler('ICS'),
      label: i18n.t('calendar.apple'),
      icon: 'apple'
    }
  ]
}

export enum BWMessageEvent {
  OPEN = 'open-widget',
  CLOSE = 'close-widget'
}

export enum BWMessageEventWithData {
  SEND_PARENT_HEIGHT = 'sendParentHeight',
  SDK_LOCATION_HREF = 'sdkLocationHref'
}

export const WIDE_ROUTES = ['form', 'thank_you', 'credit_card_imprint', 'prepayment']
export const SUM_PADDING_SDK = 32

export const PATHNAMES_NOT_IN_BOOKING_FLOW = [
  '/cookie_policy',
  '/gtc',
  '/privacy_policy',
  '/privacy_policy_short',
  '/privatisation',
  '/shop'
]
